import { formatDistanceToNow } from "date-fns";
import type { AppNotification } from "../types";

const TYPE_ICON: Record<string, string> = {
  casting_brief_invitation: "🎬",
  casting_brief_created: "📋",
  brief_selection: "⭐",
  blog_approved: "✅",
  talent_approved: "✅",
  brief_status_changed: "📢",
  profile_update_reviewed: "👤",
  profile_update_submitted: "✏️",
  system: "🔔",
};

interface Props {
  notification: AppNotification;
  onClick: (n: AppNotification) => void;
}

export default function NotificationItem({ notification: n, onClick }: Props) {
  const icon = TYPE_ICON[n.type] ?? "🔔";
  const time = (() => {
    try { return formatDistanceToNow(new Date(n.createdAt), { addSuffix: true }); }
    catch { return ""; }
  })();

  return (
    <button
      onClick={() => onClick(n)}
      className={`w-full text-start flex items-start gap-3 px-4 py-3 hover:bg-gray-50 transition-colors ${!n.isRead ? "bg-[#b2d12e]/5" : ""}`}
    >
      <span className="text-lg mt-0.5 flex-shrink-0">{icon}</span>
      <div className="flex-1 min-w-0">
        {n.title && (
          <p className={`text-sm font-semibold leading-snug ${!n.isRead ? "text-gray-900" : "text-gray-700"}`}>
            {n.title}
          </p>
        )}
        <p className={`text-sm leading-snug ${!n.isRead && !n.title ? "font-semibold text-gray-900" : "text-gray-600"}`}>
          {n.message}
        </p>
        <p className="text-xs text-gray-400 mt-1">{time}</p>
      </div>
      {!n.isRead && <span className="w-2 h-2 rounded-full bg-[#b2d12e] flex-shrink-0 mt-1.5" />}
    </button>
  );
}
